import { UserRole } from '@eppendorf/vnls-user-tenant-utils';

import { roleDisplayNameMap } from '$features/shared/user-role-map';

export function stringifyUserRoles(roles: UserRole[]): string {
  return (
    roles
      // eslint-disable-next-line security/detect-object-injection -- we want this
      .map((role) => roleDisplayNameMap[role])
      .join(', ')
  );
}
